import React, { Fragment, useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Paper, Container, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function EirPrequalError(props) {
    const [openDialog, setOpenDialog] = useState(true);
    const handleRetry = () => {
        setOpenDialog(false);
    };

    return (
        <Fragment>
            <Dialog open={openDialog}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogTitle id='alert-dialog-title'>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        {props.error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color='primary'
                        autoFocus
                        onClick={handleRetry}
                    >
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )


}
